import { MatchedSignal } from 'us-web-services';
import { SIGNAL_TYPE_LABELS } from './constants';

export interface SignalValueGroup {
  value: string;
  blockedUserIds: number[];
  weight: number;
}

export function parseMatchedSignals(json: string | null): MatchedSignal[] {
  if (!json) return [];

  try {
    return JSON.parse(json) as MatchedSignal[];
  } catch {
    return [];
  }
}

export function signalSummary(signals: MatchedSignal[]): string {
  const types = [...new Set(signals.map((s) => s.signalType))];

  return types.map((t) => SIGNAL_TYPE_LABELS[t] || t).join(', ');
}

export function groupSignals(
  signals: MatchedSignal[]
): Record<string, SignalValueGroup[]> {
  const byType: Record<string, Map<string, SignalValueGroup>> = {};

  signals.forEach((signal) => {
    if (!byType[signal.signalType]) byType[signal.signalType] = new Map();

    const bucket = byType[signal.signalType];
    const existing = bucket.get(signal.signalValue);

    if (existing) {
      if (!existing.blockedUserIds.includes(signal.blockedUserId)) {
        existing.blockedUserIds.push(signal.blockedUserId);
      }
    } else {
      bucket.set(signal.signalValue, {
        value: signal.signalValue,
        blockedUserIds: [signal.blockedUserId],
        weight: signal.weight,
      });
    }
  });

  return Object.fromEntries(
    Object.entries(byType).map(([type, bucket]) => [type, Array.from(bucket.values())])
  );
}
